import React, { ReactElement, ReactNode } from 'react'
import type { AppProps } from 'next/app'
import '@olxbr/ds-web/lib/styles.css'
import '@olxbr/ds-core/dist/olx/tokens.css'
import '@olxbr/ds-core/dist/reset.css'
import '@olxbr/ds-core/dist/styles.css'
import '@olxbr/ds-core/dist/utilities.css'
import '@olxbr/olx-components/dist/styles.css'
import '../styles/globals.css'
import DatadogInit from '@/components/datadog-init'
import { AbTestStorage } from '@olxbr/js-master-splitter'
import { GlobalStyles } from '@olxbr/pos-react-components'

type AppPropsWithLayout = AppProps & {
  Component: AppProps['Component'] & {
    getLayout?: (page: ReactElement) => ReactNode
  }
}

function Root({ Component, pageProps }: AppPropsWithLayout) {
  AbTestStorage.registerUserCurrentTests(pageProps.testAbGroups)

  const getLayout = Component.getLayout ?? ((page) => page)

  return (
    <>
      <DatadogInit datadogConfig={pageProps.datadogConfig || {}} />
      <GlobalStyles />
      {getLayout(<Component {...pageProps} />)}
    </>
  )
}

export default Root
